import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PaymentReportLayer from "../components/PaymentReportLayer";

const PaymentReportPage = () => {
    return (
        <MasterLayout>
            <PaymentReportLayer />
        </MasterLayout>
    );
};

export default PaymentReportPage;
